import { render } from "./recapMomo.vue?vue&type=template&id=33047e3f&scoped=true"
import script from "./recapMomo.vue?vue&type=script&lang=js"
export * from "./recapMomo.vue?vue&type=script&lang=js"

import "./recapMomo.vue?vue&type=style&index=0&id=33047e3f&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33047e3f"]])

export default __exports__